import { HelperService } from './../../../Services/helper.service';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { UserDto } from '../../../models/dto/user.dto';
import { AuthService } from '../../../Services/auth.service';
import { getDefaultCalendarConfig, localizeDatePicker } from '../../../helpers/translateCalendar';

@Component({
  selector: 'app-activity-log-modal',
  templateUrl: './activity-log-modal.component.html',
  styleUrls: ['./activity-log-modal.component.css']
})
export class ActivityLogModalComponent {
  @ViewChild('classic') public templateRef: TemplateRef<any>;
  modalReference: NgbModalRef;
  requestedDateRange: { startDate: moment.Moment, endDate: moment.Moment };
  startDate: string;
  endDate: string;
  profile: UserDto;
  locale = getDefaultCalendarConfig();

  ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
    size: 'xl'
  };

  constructor(
    private modalService: NgbModal,
    private translate: TranslateService,
    private authService: AuthService,
    private helper: HelperService) { }

  open() {
    this.modalReference = this.modalService.open(this.templateRef, this.ngbModalOptions);
  }

  async ngOnInit() {
    await this.getProfile();
    this.locale = localizeDatePicker(this.translate);
  }

  async getProfile() {
    this.profile = await this.authService.getUserProfile();
  }

  applyFilterByReqDate() {
    this.startDate = this.requestedDateRange?.startDate ? this.requestedDateRange.startDate.toISOString() : undefined;
    this.endDate = this.requestedDateRange?.endDate ? this.requestedDateRange.endDate.toISOString() : undefined;
  }

  async downloadLogs() {
    await this.helper.downloadActivityLog('activityLogs', this.startDate, this.endDate);
    this.modalReference.close();
  }
}
